import { render, staticRenderFns } from "./ServiceCooperationManagement.vue?vue&type=template&id=3d0632dd&scoped=true"
import script from "./ServiceCooperationManagement.vue?vue&type=script&lang=js"
export * from "./ServiceCooperationManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceCooperationManagement.vue?vue&type=style&index=0&id=3d0632dd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0632dd",
  null
  
)

export default component.exports